import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';
import { SORTED_ARTICLES, NEWS_CATEGORIES } from '../data/newsArticles';
import { PAGE_SEO } from '../utils/pageSeo';
import '../styles/aiNewsHub.css';

const ALL_FILTER = 'All';

const AINewsHub = () => {
  const { language } = useLanguage();
  const [activeFilter, setActiveFilter] = useState(ALL_FILTER);

  const filters = [ALL_FILTER, ...Object.values(NEWS_CATEGORIES)];

  const filteredArticles = useMemo(() =>
    activeFilter === ALL_FILTER
      ? SORTED_ARTICLES
      : SORTED_ARTICLES.filter(a => a.category === activeFilter),
    [activeFilter]
  );

  const seo = PAGE_SEO.aiNewsHub;

  return (
    <div style={{ background: 'var(--bg-primary)', minHeight: '100vh' }}>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath={`/${language}/ai-news`}
      />

      {/* Hero */}
      <section className="news-hero">
        <div className="container">
          <span className="news-hero-tag">AI Intelligence</span>
          <h1>AI News Hub</h1>
          <p className="news-hero-subtitle">
            Curated deep-dives on the milestones, breakthroughs, and governance shifts
            redefining artificial intelligence - from the moment ChatGPT changed everything
            to the frontier models reshaping industry today.
          </p>
        </div>
      </section>

      {/* Filter + Grid */}
      <section style={{ padding: '0 0 40px' }}>
        <div className="container">
          <div className="news-filter-bar">
            {filters.map(f => (
              <button
                key={f}
                className={`news-filter-btn${activeFilter === f ? ' active' : ''}`}
                onClick={() => setActiveFilter(f)}
              >
                {f}
              </button>
            ))}
          </div>

          <div className="news-grid">
            {filteredArticles.map(article => (
              <Link
                key={article.slug}
                to={`/${language}/ai-news/${article.slug}`}
                className="news-card"
              >
                {article.cardImage && (
                  <div className={`news-card-media${article.cardImageVariant ? ` news-card-media--${article.cardImageVariant}` : ''}`}>
                    <img
                      src={article.cardImage}
                      alt={article.cardImageAlt || ''}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                )}
                <div className="news-card-header">
                  <span className={`news-category-badge ${article.category}`}>
                    {article.category}
                  </span>
                  <span className="news-date">{article.displayDate}</span>
                </div>

                <h2 className="news-card-title">{article.title}</h2>
                <p className="news-card-excerpt">{article.excerpt}</p>

                <div className="news-card-tags">
                  {article.tags.slice(0, 4).map(tag => (
                    <span key={tag} className="news-tag">#{tag}</span>
                  ))}
                </div>

                <div className="news-card-cta">
                  Read more <span>→</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AINewsHub;
